export const DRAFT_PREFIX = "ros.draft.v1:";

export function readDraft(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeDraft(storageKey, value) {
  try {
    localStorage.setItem(storageKey, JSON.stringify({ savedAt: Date.now(), value }));
  } catch {
    /* private mode / quota: the server draft is still the fallback */
  }
}

export function removeDraft(storageKey) {
  try {
    localStorage.removeItem(storageKey);
  } catch {
    /* ignore */
  }
}

// Called on logout so evaluation text never outlives the session on a shared machine.
export function clearAllDrafts() {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(DRAFT_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    /* ignore */
  }
}
